/*globals $:false */

import { ConfirmDialog } from '@cob/ui-genesis/helpers/cob.dialog.js';

import { sprintf } from 'sprintf-js';

import tmpl_domain_defs from '../templates/domain-definitions.dot';
import tmpl_domain_edit from '../templates/domain-edit.dot';
import tmpl_domains from '../templates/domains.dot';

import utils from '@cob/ui-genesis/cob.utils.js';

// $container: the jquery HTML wrapper for the enclosing element
//
// callbacks:
//
// * `getDomain(domainId)`: get the domain with this domainId
// * `createDomain(name)`: Create a domain with this name.
// * `updateDomain(domain)`: Update the domain
// * `deleteDomain(domainId)`: delete the domain with this domainId
// * `removeDefinitionFromDomain(domainId, definitionId)`: Remove the definition from the domain
// * `addDefinitionToDomain(domainId, definitionId)`: Add the definition to the domain
var DomainsV = function(core, $container, callbacks) {
    var $domainsContainer = $('.js-domains-container', $container),
        $domainPlaceholder = $('.placeholder', $domainsContainer) ,
        $domainsList = $('ul.list', $domainsContainer),
        $newDomainBtn = $('.js-new-domain', $domainsContainer);

    var $createDomainLi;

    var translations = {
        more: core.translateString('recordm.domains', 'domains.more'),
        less: core.translateString('recordm.domains', 'domains.less')
    };


    var _buildDomainsHtml = function(domains) {
        var $list = $(tmpl_domains({domains: domains, defsTemplate: tmpl_domain_defs }))
            .find('li.js-domain')
            .detach();
        core.translate('recordm.domains', $list);

        $list.each(function(idx, el) {
            var $domainEl = $(el);

            // The user can only add definitions to this domain if the
            // $domainEl has the class js-droppable, which is
            // the same to say that the user can update this domain
            if ($domainEl.hasClass("js-droppable")) {
                $domainEl.droppable({
                    activeClass: 'ui-domain-drop',
                    hoverClass: 'ui-domain-drop-hover',
                    drop: function(event, ui) {
                        callbacks.addDefinitionToDomain($(el).data('domain-id'), ui.draggable.data('definition-id'));
                    }
                });
            }

        });

        return $list;
    };

    var _showDomains = function(domains) {
        $domainsList.html(_buildDomainsHtml(domains));
    };

    var _showDomainPlaceholder = function() {
        $domainPlaceholder.removeClass('hidden');
    };

    var _hideDomainPlaceholder = function() {
        $domainPlaceholder.addClass('hidden');
    };

    var _showDomainBody = function(domainId) {
        $domainsList.find('li[data-domain-id="' + domainId + '"] .js-body-toggle')
            .removeClass("js-more")
            .addClass("js-less")
            .text(translations.less);
    };

    var _hideDomainBody = function(domainId) {
        $domainsList.find('li[data-domain-id="' + domainId + '"] .js-body-toggle')
            .removeClass("js-less")
            .addClass("js-more")
            .text(translations.more);
    };

    var _updateDomain = function(domainId, domain) {
        var $domainItem = $domainsList.find('li[data-domain-id="' + domainId + '"]');

        $domainItem.find(".js-domain-name").text(domain.name);
        $domainItem.find(".js-domain-definitions .accordion-inner").html(tmpl_domain_defs({
           definitions: domain.definitions,
           canRemove: domain._links && domain._links.update
         }));

        if ($container.is(":visible")) {
            $domainItem.effect('highlight', {color: '#fcdebc'}, 1000);
        }
    };

    var _deleteDomain = function(domainId) {
        $domainsList.find('li[data-domain-id="' + domainId + '"]').remove();
    };

    var _updateDefinitionName = function(definitionId, newName) {
        var definitions = $domainsList.find('*[data-definition-id="' + definitionId + '"]');

        definitions.each(function(idx, el) {
            var $definition = $(el),
                $name = $(".js-definition-name", $definition);

            $name.text(newName);

            utils.delayed(function() {
                if ($definition.is(":visible")) {
                    $definition.effect('highlight', {color: '#fcdebc'}, 1000);
                }
            }, 500);

        });
    };

    var _removeDefinitonFromDomain = function(domainId, definitionId) {
        $domainsList.find('li[data-domain-id="' + domainId + '"]')
            .find('*[data-definition-id="' + definitionId + '"]')
            .remove();
    };

    var _removeDefinitionFromAllDomains = function(definitionId) {
        $domainsList.find('*[data-definition-id="' + definitionId + '"]').remove();
    };

    var _addDefinitionToDomain = function(domainId, definition) {

        var domain = callbacks.getDomain(domainId),
            $domainEl = $domainsList.find('li[data-domain-id="' + domainId + '"]');

        if ($domainEl.find('*[data-definition-id="' + definition.id + '"]').length === 0) {

            var $definitionItems = $(tmpl_domain_defs({
               definitions: [definition],
               canRemove: domain._links && domain._links.update
            }));

            $domainEl.find('.accordion-inner').append($definitionItems);

            // Avoid an error qith jquery animate when the $container
            // is not visible
            if ($container.is(":visible")) {
                $definitionItems.effect('highlight', {color: '#fcdebc'}, 1000);
            }
        }
    };


    var _showCreateDomainBlock = function() {
        var domain = {name: ""} || domain;

        // Block the button to create other domains
        $newDomainBtn.addClass("disabled").prop("disabled", true);

        $createDomainLi = $('<li class="domain-item item">' + tmpl_domain_edit({domain: domain}) + '</li>');

        core.translate('recordm.domains', $createDomainLi);

        $createDomainLi.on('click', '.js-cancel', function() {
            _removeCreateDomainBlock();
        });

        $createDomainLi.on('click', '.js-save', function() {
            callbacks.createDomain($createDomainLi.find('*[data-field="name"]').val().trim());
        });

        $createDomainLi.on('keyup', 'input[type="text"]', function(e) {
            if (e.keyCode === 13) {
                callbacks.createDomain($createDomainLi.find('*[data-field="name"]').val().trim());
            }
        });

        $domainsList.prepend($createDomainLi);
    };

    var _removeCreateDomainBlock = function() {
        if (!$createDomainLi) return;

        // stop listeners
        $createDomainLi.off('click', '.js-create');
        $createDomainLi.off('click', '.js-cancel');
        $createDomainLi.off('keyup', 'input[type="text"]');

        // Remove tne li with the form to create domains
        $createDomainLi.remove();

        $createDomainLi = undefined;

        // enable the button to allow create other domains
        $newDomainBtn.removeClass("disabled").prop("disabled", false);
    };

    var _showCreateDomainErrors = function(errors) {
        if (!$createDomainLi) return;

        $createDomainLi.find('.control-group').addClass('error');

        var $errorsContainer = $createDomainLi.find(".js-errors-container");

        $errorsContainer.html('');

        errors.forEach(function(error) {
            if (error.errorType) {
                $('<div class="js-error text-error error-message"></div>').text(
                    core.translateString('recordm.domains', 'domains.errors.' + error.errorType.toLowerCase())
                ).appendTo($errorsContainer);
            }
        });
    };

    var _showEditDomainBlock = function(domainId) {
        var domain = callbacks.getDomain(domainId);

        var $domainEditHtml = $(tmpl_domain_edit({
           domain: domain,
           action: 'edit'
        }));

        core.translate('recordm.domains', $domainEditHtml);

        $domainEditHtml.on('click', '.js-cancel', function() {
            _removeEditDomainBlock(domainId);
        });

        $domainEditHtml.on('click', '.js-save', function() {
            domain.name = $domainEditHtml.find('*[data-field="name"]').val().trim();
            callbacks.updateDomain(domain);
        });

        $domainEditHtml.on('keyup', 'input[type="text"]', function(e) {
            if (e.keyCode === 13) {
                domain.name = $domainEditHtml.find('*[data-field="name"]').val().trim();
                callbacks.updateDomain(domain);
            }
        });

        var $domainEl = $domainsList.find('.js-domain[data-domain-id="' + domain.id + '"]');

        $domainEl.find('.js-domain-info-wrapper').addClass("hidden");
        $domainEl.find('.js-edit-domain-wrapper').removeClass("hidden").html($domainEditHtml);
    };

    var _removeEditDomainBlock = function(domainId) {
        var $domainEditHtml = $domainsList.find('.js-domain[data-domain-id="' + domainId + '"] .js-edit-domain');

        $domainEditHtml.html('');

        $domainEditHtml.off('click', '.js-save');
        $domainEditHtml.off('click', '.js-cancel');
        $domainEditHtml.off('keyup', 'input[type="text"]');

        var $domainEl = $domainsList.find('.js-domain[data-domain-id="' + domainId + '"]');

        $domainEl.find('.js-edit-domain-wrapper').addClass("hidden");
        $domainEl.find('.js-domain-info-wrapper').removeClass("hidden");
    };

    var _showEditDomainErrors = function(domainId, errors) {
        var $domainEditHtml = $domainsList.find('.js-domain[data-domain-id="' + domainId + '"] .js-edit-domain');

        $domainEditHtml.find('.control-group').addClass('error');

        var $errorsContainer = $domainEditHtml.find(".js-errors-container");
        $errorsContainer.html('');

        errors.forEach(function(error) {
            if (error.errorType) {
                $('<div class="js-error text-error error-message"></div>').text(
                    core.translateString('recordm.domains', 'domains.errors.' + error.errorType.toLowerCase())
                ).appendTo($errorsContainer);
            }
        });
    };


    var _addListenersToDomainContainer = function() {
        $newDomainBtn.on('click', _showCreateDomainBlock);

        $domainsList.on('click', '.js-remove-definition', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $el = $(this),
                definitionId = $el.parents('*[data-definition-id]').data('definition-id'),
                domainId = $el.parents('.js-domain').data('domain-id');

            callbacks.removeDefinitionFromDomain(domainId, definitionId);
        });

        $domainsList.on('click', '.js-delete', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $domainItem = $(this).parents('.js-domain'),
                domainName = $domainItem.find('.js-domain-name').text().trim();

            ConfirmDialog(core, {
                    message: sprintf(core.translateString('recordm.domains', 'domains.msg.delete'), domainName),
                    confirmBtnLabel: core.translateString('recordm.domains', 'domains.actions.delete'),
                    confirmBtnClass: 'btn-danger'
                },
                {
                    requestConfirmed: function() {
                        callbacks.deleteDomain($domainItem.data('domain-id'));
                    }
                }
            );
        });

        $domainsList.on('click', '.js-edit', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            _showEditDomainBlock($(this).parents('.js-domain').data('domain-id'));
        });

        $domainsList.on('click', '.js-more', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            _showDomainBody($(this).parents('.js-domain').data('domain-id'));
        });

        $domainsList.on('click', '.js-less', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            _hideDomainBody($(this).parents('.js-domain').data('domain-id'));
        });
    };

    var _destroy = function() {
        $domainsList.off('click', '.js-less');
        $domainsList.off('click', '.js-more');
        $domainsList.off('click', '.js-edit');
        $domainsList.off('click', '.js-delete');
        $domainsList.off('click', '.js-remove-definition');
        $newDomainBtn.off('click', _showCreateDomainBlock);
    };

    var _init = function() {
        _addListenersToDomainContainer();
    };

    return {
        init: _init,
        destroy: _destroy,

        showDomains: _showDomains,
        showDomainPlaceholder: _showDomainPlaceholder,

        updateDomain: _updateDomain,
        deleteDomain: _deleteDomain,

        removeCreateDomainBlock: _removeCreateDomainBlock,
        showCreateDomainErrors: _showCreateDomainErrors,

        removeEditDomainBlock: _removeEditDomainBlock,
        showEditDomainErrors: _showEditDomainErrors,

        updateDefinitionName: _updateDefinitionName,
        removeDefinitionFromDomain: _removeDefinitonFromDomain,
        removeDefinitionFromAllDomains: _removeDefinitionFromAllDomains,
        addDefinitionToDomain: _addDefinitionToDomain
    }
};

export default DomainsV;
